// extracted by mini-css-extract-plugin
module.exports = {"footerArticle":"styles_footerArticle__imLhW","releaseDate":"styles_releaseDate__OmCOE"};